<div *ngIf="selectedBoard">
  <div fxLayout="row">
    <h3 class="m-0 m-r-20" fxLayoutAlign="start center">{{selectedBoard.boardName}}</h3>
    <button mat-icon-button class="m-r-0" (click)="openMessages()" matTooltip="Notification">
      <mat-icon>message</mat-icon>
      <div class="notify" *ngIf="communicationMessages.length">
        <span class="heartbit" [ngStyle]="{'border-color': notificationSettings.heartbitColor}"
          *ngIf="notificationSettings.showHeartbit"></span>
        <span class="point" [ngStyle]="{'background': notificationSettings.pointColor}"
          *ngIf="notificationSettings.showPoint"></span>
      </div>
    </button>
    <button mat-icon-button (click)="openQueueFilter()" matTooltip="Show/Hide queue">
      <mat-icon>filter_alt</mat-icon>
      <div class="notify" *ngIf="queueFilters.length">
          <span class="point filter"></span>
      </div>
    </button>
  </div>
  <div fxLayout="row" class="queue-container" cdkDropListGroup>
    <div [ngClass]="{'queue': !queue.hidden}" *ngFor="let queue of allQueues; let i = index; trackBy: trackByMethod">
      <div class="ticket-container" *ngIf="!queue.hidden">
        <div class="title" fxLayoutAlign="space-between start">
          <span>{{queue.queueName}} <span class="font-16"
              *ngIf="queue.tasks&&queue.tasks.length>0">({{(queue.tasks | sortTask: filters).length}})</span></span>
          <span class="m-r-10 menu_horiz pointer">
            <mat-icon [matMenuTriggerFor]="menu" *ngIf="queue.status==='Active'">more_horiz</mat-icon>
            <mat-menu #menu="matMenu">
              <button class="menu-item" mat-menu-item [matMenuTriggerFor]="moveQueue">
                Move List
              </button>
              <button class="menu-item" mat-menu-item (click)="removeQueue(queue)">
                Archive This List
              </button>
              <!-- <button class="menu-item" mat-menu-item (click)="moveAllCards(queue)">
              Move All Cards
            </button> -->
              <!-- <button class="menu-item" mat-menu-item (click)="archiveAllCards(queue)">
              Archive All Cards
            </button> -->
            </mat-menu>
            <mat-menu #moveQueue="matMenu">
              <div class="move-queue">Position</div>
              <button mat-menu-item class="pointer" fxLayoutAlign="start center"
                *ngFor="let item of positionQueue; let m=index;" (click)="changePosition(queue, i, m)"
                [disabled]="item===queue.id">
                {{m+1}}
                <span *ngIf="item===queue.id" class="m-l-5">(Current)</span>
              </button>
            </mat-menu>
          </span>
        </div>
        <div class="m-b-10" *ngIf="queue.status === 'In-Processing'">Queue update is in process please wait...</div>
        <!--<div [id]="queue.id" cdkDropList [cdkDropListData]="queue.tasks" [ngClass]="['queue'+i, 'card-container']"  (cdkDropListDropped)="drop($event)"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      [infiniteScrollContainer]="queue.className"
      [fromRoot]="true"
      (scrolled)="onScroll(queue)"> -->
        <cdk-virtual-scroll-viewport *ngIf="queue.status==='Active'" itemSize="170" style="height: 76vh;">
          <mat-card class="queue-card"
            *cdkVirtualFor="let task of queue.tasks | sortTask: filters; trackBy: trackByMethod">
            <!--cdkDrag-->
            <mat-card-content>
              <div fxLayout="row warp" *ngIf="task.labelObjects.length">
                <mat-lable *ngFor="let label of task.labelObjects; trackBy: trackByMethod"
                  [ngStyle]="{'background': label.labelColor}"
                  [ngClass]="{'round-label': !isExpandLabel, 'square-label': isExpandLabel}" class="pointer"
                  (click)="onExpandCollaps()" [matTooltip]="label.labelText">
                  <span *ngIf="isExpandLabel">{{label.labelText}}</span>
                </mat-lable>
              </div>
              <div class="patient-card pointer" (click)="onPatientNameClick(task)" *ngIf="task.text"
                [innerHTML]="task.text.div | safeHtml" [matTooltip]="tooltip.score"></div>
              <h6 class="text-muted m-0 m-b-5" *ngIf="task.effectiveDate" fxLayoutAlign="start center"
                [matTooltip]="tooltip.dashboard">
                <mat-icon class="font-20" fxLayoutAlign="start center">dashboard</mat-icon><span>
                  {{task.effectiveDate | date :'MM-DD HH:mm'}} ({{getDisplayDate(task.effectiveDate)}})</span>
              </h6>
              <h6 class="text-muted m-0 m-b-5" *ngIf="task.authoredOn" fxLayoutAlign="start center"
                [matTooltip]="tooltip.queue">
                <mat-icon class="font-20">access_time</mat-icon> in queue: <span
                  class="m-l-5">{{getDisplayDate(task.authoredOn)}}</span>
              </h6>
              <div fxLayout="row wrap" fxLayoutAlign="end end">
                <div class="m-r-10 gray" [matTooltip]="tooltip.label">
                  <mat-icon (click)="openLablePopup(task)" class="pointer">color_lens</mat-icon>
                </div>
                <div class="m-r-10 pointer gray" (click)="autoMoveCard(task, queue)" [matTooltip]="tooltip.forward">
                  <mat-icon color="primary">forward</mat-icon>
                </div>
                <div class="pointer remove" (click)="removeCard(task, queue)" [matTooltip]="tooltip.remove">
                  <mat-icon color="warn">delete_outline</mat-icon>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </cdk-virtual-scroll-viewport>

        <div *ngIf="queue.status!=='Active'" class="card-container" [ngStyle]="{'height': '76vh', 'overflow':'hidden'}">
          <mat-card class="queue-card" *ngFor="let task of fakeTasks">
            <mat-card-content>
              <div class="m-t-5 m-b-10">
                <ngx-skeleton-loader count="1" [theme]="{height: '20px', width: '70%', margin: '-3px'}">
                </ngx-skeleton-loader>
              </div>
              <div>
                <ngx-skeleton-loader count="1"
                  [theme]="{height: '20px', width: '25px', margin: '-3px', 'margin-right': '10px'}">
                </ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" [theme]="{height: '20px', width: '25px', margin: '-3px'}">
                </ngx-skeleton-loader>
              </div>
              <div class="m-b-5">
                <ngx-skeleton-loader count="1" [theme]="{height: '20px', width: '55%', margin: '-3px'}">
                </ngx-skeleton-loader>
              </div>
              <div class="p-b-5" fxLayoutAlign="end start">
                <ngx-skeleton-loader count="1"
                  [theme]="{height: '20px', width: '25px', margin: '-3px', 'margin-right': '10px'}">
                </ngx-skeleton-loader>
                <ngx-skeleton-loader count="1"
                  [theme]="{height: '20px', width: '25px', margin: '-3px', 'margin-right': '10px'}">
                </ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" [theme]="{height: '20px', width: '25px', margin: '-3px'}">
                </ngx-skeleton-loader>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="p-r-10">
      <button @fadeIn *ngIf="!isAddQueue" mat-raised-button class="add-queue-btn" (click)="enableAddQueue()">
        <mat-icon>add</mat-icon>Add another queue
      </button>
      <div class="queue" *ngIf="isAddQueue" @fadeIn>
        <form (ngSubmit)="addQueue()" [formGroup]="queueForm">
          <div class="ticket-container">
            <div class="card-container addQueue">
              <div fxLayout="row wrap">
                <mat-form-field appearance="outline">
                  <input style="background: #fff;" matInput placeholder="Queue Name" formControlName="queueName">
                </mat-form-field>
              </div>
              <div fxLayout="row wrap">
                <mat-form-field appearance="outline">
                  <textarea rows="4" matInput placeholder="Queue Description"
                    formControlName="queueDescription"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="footer" fxLayoutAlign="start center">
              <button class="m-r-15" color="primary" type="submit" mat-raised-button>Add Queue</button>
              <mat-icon class="pointer" (click)="enableAddQueue()">close</mat-icon>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>